module.exports = __webpack_public_path__ + "static/media/k12_site_home.7318abd2.jpg";